export default __webpack_public_path__ + "df155338feb744216a72f734149c757f.png";